import React, { Component } from "react"
import { Arwes } from "arwes"
import styled from "styled-components"
import { connect } from "react-redux"
import Signup from "./Signup"
import { clearSignupError, signUp } from "./redux/reducers"

const SignupSurface = styled.main`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  padding: 32px 24px 32px
    ${p => (p.isExpanded ? "264px" : "88px")};
  background-color: #030b10;
  background-image:
    repeating-linear-gradient(
      0deg,
      rgba(0, 231, 255, 0.05) 0,
      rgba(0, 231, 255, 0.05) 1px,
      transparent 1px,
      transparent 120px
    ),
    repeating-linear-gradient(
      90deg,
      rgba(0, 231, 255, 0.05) 0,
      rgba(0, 231, 255, 0.05) 1px,
      transparent 1px,
      transparent 120px
    );

  @media (max-width: 900px) {
    align-items: flex-start;
    padding-top: 24px;
    padding-bottom: 24px;
  }

  @media (max-width: 700px) {
    padding: 16px 8px 24px 72px;
  }

  @media (max-width: 360px) {
    padding-right: 4px;
    padding-left: 68px;
  }
`

const SignupWidth = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 900px;
  min-width: 0;
`

class SignupContainer extends Component {
  componentDidMount() {
    this.props.clearSignupError()
  }

  handleSubmit = values =>
    this.props.signUp({
      ...values,
      name: (values.name || "").trim(),
      email: (values.email || "").trim()
    })

  handleFieldChange = () => {
    if (this.props.user && this.props.user.signupError) {
      this.props.clearSignupError()
    }
  }

  render() {
    const { user, isExpanded } = this.props

    return (
      <Arwes>
        <SignupSurface isExpanded={isExpanded}>
          <SignupWidth>
            <Signup
              onSubmit={this.handleSubmit}
              signupError={user && user.signupError}
              onFieldChange={this.handleFieldChange}
            />
          </SignupWidth>
        </SignupSurface>
      </Arwes>
    )
  }
}

const mapStateToProps = state => ({
  user: state.user
})

export default connect(mapStateToProps, { clearSignupError, signUp })(
  SignupContainer
)
